import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import favicon from './assets/images/favicon.png';

document.title = 'DAI Group | Data to AI';

const existingIcon = document.querySelector('link[rel~="icon"]');
if (existingIcon) {
  existingIcon.href = favicon;
} else {
  const iconLink = document.createElement('link');
  iconLink.rel = 'icon';
  iconLink.href = favicon;
  document.head.appendChild(iconLink);
}

const existingShortcutIcon = document.querySelector('link[rel="shortcut icon"]');
if (existingShortcutIcon) {
  existingShortcutIcon.href = favicon;
}

const existingAppleIcon = document.querySelector('link[rel="apple-touch-icon"]');
if (existingAppleIcon) {
  existingAppleIcon.href = favicon;
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

reportWebVitals();
